import { render, staticRenderFns } from "./Result.vue?vue&type=template&id=0b3b1b10&scoped=true&"
import script from "./Result.vue?vue&type=script&lang=js&"
export * from "./Result.vue?vue&type=script&lang=js&"
import style0 from "./Result.vue?vue&type=style&index=0&id=0b3b1b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3b1b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b3b1b10')) {
      api.createRecord('0b3b1b10', component.options)
    } else {
      api.reload('0b3b1b10', component.options)
    }
    module.hot.accept("./Result.vue?vue&type=template&id=0b3b1b10&scoped=true&", function () {
      api.rerender('0b3b1b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popup/Result.vue"
export default component.exports